import { render, staticRenderFns } from "./CustomerClosedTickets.vue?vue&type=template&id=8a8ebf7e&scoped=true&"
import script from "./CustomerClosedTickets.vue?vue&type=script&lang=js&"
export * from "./CustomerClosedTickets.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClosedTickets.vue?vue&type=style&index=0&id=8a8ebf7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ebf7e",
  null
  
)

export default component.exports